import FolderOutlined from '@mui/icons-material/FolderOutlined';
import PeopleOutline from '@mui/icons-material/PeopleOutline';
import { Stack, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { ColumnHeaderWithTooltip } from 'v2/components/ColumnHeaderWithTooltip/ColumnHeaderWithTooltip';

export const GroupsColumnHeader: React.FC = () => {
  const { translation } = useTranslation();

  return (
    <ColumnHeaderWithTooltip
      label={translation.groups}
      tooltip={
        <Stack spacing={1}>
          <Typography variant="caption">{translation.devices_need_group_tooltip}</Typography>
          <Stack spacing={0.5}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <FolderOutlined fontSize="extraSmall" />
              <Typography variant="caption">{translation.device_group}</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
              <PeopleOutline fontSize="extraSmall" />
              <Typography variant="caption">{translation.user_group}</Typography>
            </Stack>
          </Stack>
        </Stack>
      }
    />
  );
};
